import { OPTION_LIST } from '@/constants/context';

interface ConjunctionSelectProps {
  selected: string;
  setSelected: (value: string) => void;
  type: string;
}

const ConjunctionSelect: React.FC<ConjunctionSelectProps> = ({
  selected,
  setSelected,
  type,
}) => {
  const getSelectClasses = () => {
    if (type === 'CALENDAR') {
      return 'border border-black rounded-[4px] !text-xl bg-transparent text-black font-bold text-center outline-none w-full h-8 text-base md:w-[7.5rem] md:h-8 md:mt-4';
    }

    return 'border border-[#FCCB16] pl-3 pr-2 text-start md:text-center md:px-0 w-full rounded-[4px] md:w-[120px] md:h-[40px] bg-transparent md:text-[20px] text-[#FCCB16] font-bold text-center text-base outline-none w-[6.5rem] h-8';
  };

  return (
    <select
      className={getSelectClasses()}
      value={selected}
      onChange={e => {
        setSelected(e.target.value);
      }}
    >
      {OPTION_LIST.map((item, index) => {
        return (
          <option
            key={index}
            value={item.value}
            className='text-black border rounded-none'
          >
            {item.label}
          </option>
        );
      })}
    </select>
  );
};

export default ConjunctionSelect;
